var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 19"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.548 22c9.056 0 14.01-7.31 14.01-13.65 0-.209 0-.415-.014-.62A9.887 9.887 0 0 0 24 5.245c-.899.388-1.852.642-2.828.755a4.835 4.835 0 0 0 2.164-2.654 10.03 10.03 0 0 1-3.127 1.165c-1.865-1.932-4.983-2.025-6.967-.208a4.722 4.722 0 0 0-1.423 4.583C7.86 8.693 4.17 6.872 1.67 3.874.364 6.067 1.03 8.872 3.194 10.28A4.973 4.973 0 0 1 .96 9.678v.06c.001 2.284 1.652 4.25 3.95 4.703a5.022 5.022 0 0 1-2.223.083c.645 1.955 2.493 3.293 4.6 3.333A10.049 10.049 0 0 1 0 19.845a14.207 14.207 0 0 0 7.548 2.151",
    id: "Twitter_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#Twitter_svg__a"
  }))));
};
export default SvgTwitter;